export default "__VITE_ASSET__$TytcpwS__";